import {CommonMessages} from '../common.messages';

export const PanelReportsExecutionsMessages = {
    GetTradingGroupsFailed: {
        key: 'GetTradingGroupsFailed',
        message: 'Error while communication with the server. Unable to get trading groups.'
    },
    ExportExecutionReportFailed: {
        key: 'ExportExecutionReportFailed',
        message: 'Error while communication with the server. Unable to export report.'
    },
    ExportExecutionReportRequested: {
        key: 'ExportExecutionReportRequested',
        message: 'Export request has been sent to the server.'
    },
    GetExecutionsReportFailed: {
        key: 'GetExecutionsReportFailed',
        message: 'Error while communication with the server. Unable to get Executions report.'
    },
    WrongQuantityTo: {
        key: 'WrongQuantityTo',
        message: 'Quantity To must be greater than Quantity From'
    },
    WrongPriceTo: {
        key: 'WrongPriceTo',
        message: 'Price To must be greater than Price From'
    },
    WrongDateTo: {
        key: 'WrongDateTo',
        message: 'Date To must be greater than Date From'
    },
    ReportPeriodExceeded: {
        key: 'ReportPeriodExceeded',
        message: 'Report period must not exceed 31 days'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    ...CommonMessages
};
